<div class="popup flex flex-col justify-content-between">
    <!-- <label
        for="fileInput"
        class="flex flex-col align-items-center text-center cursor-pointer my-5"
    >
        <mat-icon [svgIcon]="'heroicons_outline:arrow-up-tray'" class="upload-icon w-full"></mat-icon>
        <p class="bold mt-3">Drag & Drop</p>
        <p>your files here, or click to browse</p>
        
        <input
            id="fileInput"
            type="file"
            (change)="onFileSelected($event)"
            class="hidden-input"
            #fileInput
            multiple
        />
        <p *ngIf="selectedFiles?.length" class="mt-3 mb-1 font-bold">{{getSelectedFilesText()}}</p>
    </label> -->

    <div *ngIf="title" class="text-center text-lg">{{title}}</div>

    <ngx-dropzone
        #dropzone
        (change)="onFilesAdded($event)"
        class="main-dropzone my-5"
        [multiple]="multiple"
    >
        <ngx-dropzone-label>
            <div>
                <mat-icon class="material-icons-outlined icon-size-7" svgIcon="mat_outline:upload_file"></mat-icon>
            </div>
            <div class="mt-4">
                <small>Browse or drop<br/>file{{multiple ? '(s)' : ''}} here.</small>
            </div>
        </ngx-dropzone-label>
    </ngx-dropzone>

    <div *ngIf="files?.length" class="mb-5 flex flex-wrap gap-x-4 max-w-[30vw] justify-center">
        <ng-container *ngFor="let file of getFileList()">
            <small class="cursor-pointer" matTooltip="Click to remove" (click)="removeFile(file.name)">{{file.name}}</small>
        </ng-container>
    </div>


    <div class="flex flex-row justify-end w-full mt-auto">
        <button
            class="mr-2"
            mat-flat-button
            (click)="onClose()"
        >
            Cancel
        </button>

        <button
            mat-raised-button
            color="primary"
            (click)="onUpload()"
            [disabled]="!files?.length"
        >
            Upload
        </button>
    </div>
</div>
